var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 36,
    viewBox: "0 0 26 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2427 11.063L20.9714 13.9888L20.2087 15.7697L18.3018 20.222C17.2848 22.5117 16.0136 23.7838 12.9626 23.7838H10.4201L8.89461 23.5294L7.24199 21.7485L6.98774 20.858L6.47925 17.805L6.98774 18.3139V18.5683C6.98774 19.3315 7.36912 20.0948 7.87761 20.6036C8.38611 21.1125 9.14886 21.4941 10.0387 21.4941C11.31 21.4941 12.327 20.7308 12.8355 19.7132V19.586L13.2168 18.5683L14.8694 14.6248C16.0136 11.8262 17.2848 11.1902 20.2087 11.1902H22.2427V11.063Z",
    fill: "#5C79AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1718 11.063L20.3921 15.1337C21.4091 12.9711 21.9176 11.8262 22.9346 11.063H22.1718Z",
    fill: "#5C79AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0095 33.7102L21.9925 32.0565L18.8144 26.2049C17.9245 24.6784 16.399 23.6608 14.6193 23.6608H11.4412H11.3141C10.0428 23.6608 8.51733 23.0247 7.8817 22.1343L7.75458 22.0071L7.62746 21.8799C7.50033 21.6254 7.37321 21.4982 7.24608 21.2438C7.24608 21.2438 7.24608 21.1166 7.11896 21.1166V20.9894C7.11896 20.8622 7.11896 20.8622 7.11896 20.735V20.6078V20.4806C7.11896 20.3534 7.11896 20.2262 7.11896 20.0989C7.11896 19.9717 7.11896 19.9717 7.11896 19.8445V2.67138C7.11896 1.14488 5.97484 0 4.44935 0H1.90686H0C1.14412 1.27208 1.27124 1.78092 1.27124 4.07067V19.7173C1.27124 19.8445 1.27124 19.9717 1.27124 20.2261V36H4.32222C5.84772 36 6.99183 34.8551 6.99183 33.3286V23.788C9.91569 24.1696 12.4582 25.6961 13.6023 27.7315L16.6533 33.2014C17.6703 34.9823 19.45 36 21.484 36H23.7722H24.2807H25.0435C24.0265 35.4912 23.518 34.8551 23.0095 33.7102Z",
    fill: "#26354D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKIcon);
export default __webpack_public_path__ + "static/media/KIcon.04ff71384ff5dcaeb3c738f92be3bce1.svg";
export { ForwardRef as ReactComponent };